import React from "react";
import MarkdownHtml from "../Markdown/MarkdownHtml";

/*
 * Same build-time pipeline as `Markdown` (see helpers/markdownToHtml.ts), minus
 * the `blog-content` wrapper: react-markdown only wrapped its output in a
 * `<div>` when a `className` was given, so this component used to render its
 * paragraphs straight into the call site's element.
 *
 * `dangerouslySetInnerHTML` needs a host element, so every call site now passes
 * its own wrapper classes down through `className` and drops the extra `<div>`
 * it used to wrap this component in - the emitted DOM stays identical.
 */
const SimpleMarkdown: React.FC<any> = ({ children, className }) => {
  return <MarkdownHtml className={className}>{children}</MarkdownHtml>;
};

export default SimpleMarkdown;
